export const config = {
  apiUrl: process.env.VUE_APP_API_URL,
  paramBackendToken: process.env.VUE_APP_PARAM_B_TOKEN,
  paramBackendInfo: process.env.VUE_APP_PARAM_B_INFO,
  paramWebToken: process.env.VUE_APP_PARAM_W_TOKEN,
  paramWebInfo: process.env.VUE_APP_PARAM_W_INFO,
  systemTitle: process.env.VUE_APP_APP_TITLE,
  envSuffix: process.env.VUE_APP_ENV_SUFFIX || '',
  testMode: process.env.VUE_APP_TEST_MODE === 'true'
}
